var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow2 = function SvgArrow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow2_svg__icon",
    viewBox: "0 0 1024 1024",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M797.24 934.684 366.764 512.057 797.24 89.429l-76.573-75.15L213.22 512.057l507.448 497.778z",
    fill: "#333"
  })));
};

export default SvgArrow2;